import styled from 'styled-components';

import { AceEditor } from 'modules/aceEditor/AceEditorWrapper';
import { body2, spacing } from 'ui/theme';
import { FormSectionContent } from 'modules/workflowNodeEditors/EditorBody.styled';

export const ToggleWrapper = styled.div`
  > * {
    margin-top: ${spacing.threeQuarter};
  }
`;

export const StyledAceEditor = styled(AceEditor)`
  margin-top: ${spacing.threeQuarter};
`;

export const ModalToggleLabel = styled.label`
  ${body2};
  margin-bottom: 0;
`;

export const WarningMessageWrapper = styled(FormSectionContent)`
  margin: ${spacing.threeQuarter} 0;
`;

export const AceEditorWrapper = styled.div`
  .ace_comment.ace_placeholder {
    ${body2}
    margin: ${spacing.base} 0 0 0;
  }
`;
